import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button.jsx';
import './MatchSchedule.css';

/**
 * Component for displaying upcoming scheduled matches
 * @param {Object} props
 * @param {Array} props.matches - Array of scheduled match objects
 * @param {Function} props.onLogMatch - Callback when "Log Results" is clicked
 */
export default function MatchSchedule({ matches, onLogMatch }) {
  if (!matches || matches.length === 0) {
    return (
      <div className="match-schedule empty">
        <p>No upcoming matches scheduled</p>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'TBD';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  const formatTime = (timeString) => {
    if (!timeString) return '';
    return timeString;
  };

  return (
    <div className="match-schedule">
      <h3>Upcoming Matches</h3>
      <div className="matches-list">
        {matches.map((match) => (
          <div key={match.matchId} className="match-card">
            <div className="match-header">
              <div className="match-date">
                <span className="date">{formatDate(match.scheduledDate)}</span>
                {match.scheduledTime && (
                  <span className="time">{formatTime(match.scheduledTime)}</span>
                )}
              </div>
              {match.location && (
                <div className="match-location">{match.location}</div>
              )}
            </div>

            <div className="match-teams">
              <div className="team">
                <Link to={`/teams/${match.team1Id}`} className="team-name">
                  {match.team1Name}
                </Link>
              </div>
              <div className="vs">vs</div>
              <div className="team">
                <Link to={`/teams/${match.team2Id}`} className="team-name">
                  {match.team2Name}
                </Link>
              </div>
            </div>

            <div className="match-actions">
              <Button
                variant="primary"
                onClick={() => onLogMatch(match)}
                size="small"
              >
                Log Results
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
